module.exports = __webpack_public_path__ + "img/hardshell_dorsal_labelled.24772fef.jpg";